import PropTypes from 'prop-types'
import React from 'react'

import useScrollMagic from 'hooks/useScrollMagic'
import DynamicImage from 'components/DynamicImage'
import RenderInView from 'components/RenderInView'
import { GOODS_TYPES } from 'constants/sales'
import { LocalizationContext } from 'contexts/Localization'
import useInViewCommon from 'hooks/useInViewCommon'
import { BoxBase } from 'styles/components/layout'
import { H1Small as H1 } from 'styles/components/typography'

import { Content, TextStyled } from '../styles'

import { timeline, fadeOutTl } from './animation'
import { Wrapper, BoxWrapper, BoxInner, DesktopIndicator, TitleBox } from './styles'

const WAboutCompareFirstTablet = ({ header, text, isTablet }) => {
  const { paths } = React.useContext(LocalizationContext)
  const { dna, wgs } = GOODS_TYPES
  const trigger = React.useRef()
  const fadeOutTrigger = React.useRef()
  const wgsBox = React.useRef()
  const dnaBox = React.useRef()
  const boxRef = React.useRef()
  const [ref, inView] = useInViewCommon()
  const clearStyles = ({ wgsBox, dnaBox }) => {
    wgsBox.current.removeAttribute('style')
    dnaBox.current.removeAttribute('style')
  }

  const { ScrollMagic, isScrollMagicLoaded } = useScrollMagic({ inView: inView && !isTablet })

  React.useEffect(() => {
    if (!isTablet) {
      require('animation.gsap')
    }
  }, [isTablet])

  React.useEffect(() => {
    if (!isTablet && inView && isScrollMagicLoaded) {
      const animation = timeline({ wgsBox, dnaBox })
      const controller = new ScrollMagic.Controller()
      const mainScene = new ScrollMagic.Scene({
        triggerElement: trigger.current,
        reverse: false,
      }).on('enter', () => animation.play())

      const fadeOutScene = new ScrollMagic.Scene({
        triggerElement: fadeOutTrigger.current,
        triggerHook: 0.4,
      }).setTween(fadeOutTl({ boxRef }))

      controller.addScene([mainScene, fadeOutScene])

      return () => {
        controller.destroy(true)
        animation.kill()
        clearStyles({ wgsBox, dnaBox })
      }
    }
  }, [isTablet, inView, isScrollMagicLoaded])

  return (
    <BoxBase ref={boxRef} overflow="hidden" position="relative">
      <Wrapper ref={ref}>
        <Content>
          <TitleBox ref={trigger}>
            <H1 as="h3" dangerouslySetInnerHTML={{ __html: header }} />
          </TitleBox>
          <TextStyled dangerouslySetInnerHTML={{ __html: text }} />
        </Content>

        <BoxWrapper ref={dnaBox} productType={dna}>
          <RenderInView>
            <BoxInner>
              <DynamicImage
                alt="dna-box-left"
                image={`${paths.cdn_boxes}/dna-left-new`}
                imageSizes={{ md: 411 }}
                imageType="png"
              />
            </BoxInner>
          </RenderInView>
        </BoxWrapper>

        <BoxWrapper ref={wgsBox} productType={wgs}>
          <RenderInView>
            <BoxInner>
              <DynamicImage
                alt="wgs-box-right"
                image={`${paths.cdn_boxes}/wgs-right-v2`}
                imageSizes={{ md: 411 }}
                imageType="png"
              />
            </BoxInner>
          </RenderInView>
        </BoxWrapper>
      </Wrapper>
      <DesktopIndicator ref={fadeOutTrigger} />
    </BoxBase>
  )
}

WAboutCompareFirstTablet.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
  isTablet: PropTypes.bool,
}

WAboutCompareFirstTablet.defaultProps = {
  header: '',
  text: '',
  isTablet: false,
}

export default WAboutCompareFirstTablet
